import RichText from '@/components/RichText';
import Image from 'next/image';
import { useColorProvider } from '@/utils/ColorProvider';
import { cls } from '@/utils/cls';
import styles from './HeaderV2.module.scss';
import type { FC } from 'react';
import type { HeaderV2Props } from './';
import { hasNonEmptyRichTextField } from '@/utils/richText';
const HeaderV2: FC<HeaderV2Props> = ({
  extendStyles,
  copy,
  logo,
  showMobileText = true,
  showMobileLogo = true,
  usePageColors = true,
  backgroundColor,
  textColor,
  textSize = 13,
  logoHeight = 45
}) => {
  const {
    colors
  } = useColorProvider();
  const imageSrc = logo?.value?.data?.image || '/NewDesign_logo.svg';
  const _backgroundColor = usePageColors ? colors.primaryAccentColor || '#FFF' : backgroundColor;
  const _textColor = usePageColors ? '#475569' : textColor;
  const containerClassnames = cls(styles.root, extendStyles);
  const containerStyles = {
    backgroundColor: _backgroundColor || '#FFF',
    color: _textColor || '#475569'
  };
  // show text if no elements are selected to avoid empty header
  const showTextOnMobile = showMobileText || !showMobileLogo;
  // Builder sends null for a cleared numeric input, and the destructure defaults
  // above only cover undefined — so normalise with ?? before interpolating.
  const _textSize = textSize ?? 13;
  const _logoHeight = logoHeight ?? 45;
  const textSizeStyle = {
    '--custom-font-size': `${_textSize}px`
  } as React.CSSProperties;
  const logoHeightStyle = {
    '--logo-height': `${_logoHeight}px`
  } as React.CSSProperties;
  return <div className={containerClassnames} style={containerStyles} data-sentry-component="HeaderV2" data-sentry-source-file="HeaderV2.tsx">
			<div className={styles.wrapper}>
				<Image className={showMobileLogo ? styles.logo : cls(styles.logo, styles.mobileHide)} src={imageSrc} alt={logo?.value?.data?.name || ''} width={100} height={_logoHeight} sizes="100vw" role={logo?.value?.data?.name ? undefined : 'presentation'} unoptimized style={logoHeightStyle} data-sentry-element="Image" data-sentry-source-file="HeaderV2.tsx" />
				{hasNonEmptyRichTextField(copy) && <RichText text={copy} className={showTextOnMobile ? styles.copy : cls(styles.copy, styles.mobileHide)} style={textSizeStyle} />}
			</div>
		</div>;
};
export default HeaderV2;